export default {
    products: [],
    quantityFractional: 1,
    minimumQuantityFractional: 1,
    item: null,
    itemWish: null,
    minimumQuantity: null,
    numberOfBoxesSelected: 1,
    conversionUnitWhenSellingWithClosedBox: 'UND',
    quantityProductItemsGroup: 0,
    product_price_to_bkp_discount_closed_box: null,
    product_pro_price_site_bkp_discount_closed_box: null,
    additionalItems: [],
    additionalItemsSelected: null,
    settings: null,
    flavors: [],
    quantity: 1,
    resetItemsGrid: false,
    variations: [],
    reset: false,
    bkpProduct: null,
    availability: 0
}
